import { getColorFromString } from 'office-ui-fabric-react';

export const hexToRGBA = (hex: string, alpha: number): string | undefined => {
    const fabricColor = getColorFromString(hex);

    return fabricColor && `rgba(${fabricColor.r}, ${fabricColor.g}, ${fabricColor.b}, ${alpha})`;
};
